var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.796 8.755H27.76l-6.313 7.27 6.313 7.27h2.036v5.856H16.458v-5.855h2.036L14.32 18.65h-1.73v4.847h2.34v5.856H2v-5.856h2.85V8.857H2V3h3.258V5.22H6.99v-2.22h3.156V5.22h1.73v-2.22h3.157v5.755H12.69v4.847h1.732l4.174-4.847H16.56V3H30l-.204 5.755z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeep);
export default __webpack_public_path__ + "static/media/KEEP.df963dbf67deb7aca066caa0c59c38d4.svg";
export { ForwardRef as ReactComponent };